import React from 'react';
import { useSelector } from 'react-redux';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Input, EAA_Add_Btn } from '~/components/EditAndAddItem';

const emptyBody = {
  underwater_base_type: '',
  wind_mechine_mw: 0,
  wind_mechine_num: 0,
};

const Sub1 = props => {
  const { disabled, titleWidth, checkChange, changeData, data = {}, checkSubChange } = props;
  const aProUnderWaterList = useSelector(state => state.data.AProUnderWaterList);

  const ary = data.sub1 || [];
  if (ary.length === 0)ary.push({ ...emptyBody });

  const saveSub = dataAry => {
    changeData({ label: 'sub1', data: dataAry });
  };

  const addRow = () => {
    ary.push({ ...emptyBody });
    saveSub(ary);
  };

  const delRow = n => {
    ary.splice(n, 1);
    saveSub(ary);
  };

  return ary.map((o, i) => (
    <EAA_Row key={`Page_AdminProgram_Sub1_${i}`}>
      <EAA_Item>
        <EAA_ItemContainer>
          <EAA_TitleText width={titleWidth} text={i === 0 ? '風力機單機容量' : ''} haveChange={checkSubChange(1, [emptyBody])} />
          <EAA_Input displayBorder disabled={disabled} type='number' hint='風力機單機容量' unit='MW' marginRight={8} value={o.wind_mechine_mw} onChange={data => { ary[i].wind_mechine_mw = parseFloat(data); saveSub(ary); }} />
          <EAA_Input displayBorder disabled={disabled} type='number' hint='組數(必填)' unit='組數' value={o.wind_mechine_num} onChange={data => { ary[i].wind_mechine_num = parseInt(data); saveSub(ary); }} />
        </EAA_ItemContainer>
      </EAA_Item>
      <EAA_Item>
        <EAA_ItemContainer>
          <EAA_TitleText width={titleWidth} text={i === 0 ? '水下基礎形式' : ''} haveChange={checkSubChange(1, [emptyBody])} />
          <EAA_Select displayBorder disabled={disabled} list={aProUnderWaterList} marginRight={8} value={o.underwater_base_type} onChange={data => { ary[i].underwater_base_type = data; saveSub(ary); }} />
          <EAA_Add_Btn disabled={disabled} del={i > 0} onClick={(i > 0) ? () => delRow(i) : () => addRow()} />
        </EAA_ItemContainer>
      </EAA_Item>
    </EAA_Row>
  ));
};
export default Sub1;
